<aslib-title Text="Valor mensal a distribuir" SubText="Gerar" ></aslib-title>

<form novalidate [formGroup]='formGeraroValorMensalDistribuir'>
  <div class="form-group row">
    <label for="" class="col-md-3 text-right">Mês/Ano de Referência:</label>
    <div class="controls col-md-2">
      <input type="text" appMonthYear placeholder="MM/YYYY" [(ngModel)]="dataReferenciaDistribuicao" required formControlName="dataReferenciaDistribuicao" class="form-control" />
    </div>
    <div class="col-md-2">
      <button type="button" class="btn btn-primary" (click)="consultarValorDistribuicaoValorMensal(modalMensagem)"><aslib-icon type="1" icon="fa fa-caret-right"></aslib-icon></button>
    </div>
    </div>
  <div class="form-group row">
    <label for="" class="col-md-3 text-right">Valor Royalties a Distribuir:</label>
    <div class="controls col-md-2">
      <input
        type="text"
        formControlName="valorMensalDistribuicao"
        appCurrencyMask
        placeholder="R$ 0,00"
        inputmode="numeric"
        required
        class="form-control"
      />
    </div>
  </div>

  <div class="form-group row">
    <div class="controls col-md-4 offset-md-3">
      <button type="submit" class="btn btn-primary"  [disabled]="!formGeraroValorMensalDistribuir.valid" (click)="gerarDistribuicaoValorMensal(modalMensagem)" >
        <aslib-icon type="1" icon="fa fa-check"></aslib-icon>Gerar </button>
    <button type="submit" class="btn btn-primary" (click)="limparConsulta()" >
        <aslib-icon type="1" icon="fa fa-refresh"></aslib-icon>Limpar </button>
        <button type="button" class="btn btn-primary" (click)="irPraConsulta()"  >
        <aslib-icon type="1" icon="fa fa-ban"></aslib-icon>Cancelar
      </button>
    </div>
    
  </div>


<div class="form-group row mb-5" *ngIf="exibirGrid" >
  
  <aslib-grid id="as-grid" class="col-md-12" [(dataset)]="listaDistribuicaoGerada" [pagination]="true">
        
    <aslib-grid-column [property]="'municipio'" [header]="'Município'" [width]="100" [sortable]="true"></aslib-grid-column>
    <aslib-grid-column [property]="'indiceIMP'" [header]="'Índice IPM'" [width]="40" [sortable]="true"></aslib-grid-column>

    <aslib-grid-column [property]="'valorDistribuido'"  [width]="60" [header]="'Valor Distribuído'"  [sortable]="true">
      <ng-template #AslibGridCell let-item="item">
        <span>{{item.valorDistribuido | currency:'BRL':'symbol':'1.4-4':'pt-BR'}}</span>
      </ng-template>
    </aslib-grid-column>
    <aslib-grid-column [property]="'valorArredondado'"  [width]="50" [header]="'Valor Arredondado'"  [sortable]="true">
      <ng-template #AslibGridCell let-item="item">
        <span>{{item.valorArredondado | currency:'BRL'}}</span>
      </ng-template>
    </aslib-grid-column>

  </aslib-grid>
</div>
  <div class="form-group row"  *ngIf="exibirGrid">
    <div class="col-md-12">
      <button type="submit" class="btn btn-primary" (click)="salvarValorMensalDistribuicao(modalMensagem)"  >
        <aslib-icon type="1" icon="fa fa-save"></aslib-icon>Salvar
      </button>
    </div>
  </div>

</form>
<aslib-modal #modalMensagem></aslib-modal>



// WEBPACK FOOTER //
// ./src/app/royalts/cadastra-valor-mensal/gerar-valor-mensal/gerar-valor-mensal-municipio.component.html